import { render, staticRenderFns } from "./registro.vue?vue&type=template&id=273d47d6&"
import script from "./registro.vue?vue&type=script&lang=js&"
export * from "./registro.vue?vue&type=script&lang=js&"
import style0 from "./registro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports